import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { AiAssistantRule, EAiAssistantRuleKind } from "../../aiAgents.types";
import {
  AiAssistantSubRoute,
  ApiRoutesAiAssistants
} from "../../constants/enums";

interface ListResponse {
  data: AiAssistantRule[];
}

const rulesBase = (assistantId: string) =>
  buildUrl(ApiRoutesAiAssistants.Assistants, assistantId, AiAssistantSubRoute.Rules);

export const requestGetRules = async (
  assistantId: string
): Promise<ListResponse> => await instance.get(rulesBase(assistantId));

export interface CreateRuleBody {
  assistantId: string;
  kind: EAiAssistantRuleKind;
  title: string;
  body: string;
  isEnabled?: boolean;
}

export const requestCreateRule = async ({
  assistantId,
  ...body
}: CreateRuleBody): Promise<AiAssistantRule> =>
  await instance.post(rulesBase(assistantId), body);

export interface UpdateRuleBody {
  assistantId: string;
  ruleId: string;
  title?: string;
  body?: string;
  isEnabled?: boolean;
}

export const requestUpdateRule = async ({
  assistantId,
  ruleId,
  ...body
}: UpdateRuleBody): Promise<AiAssistantRule> =>
  await instance.patch(buildUrl(rulesBase(assistantId), ruleId), body);

export interface DeleteRuleBody {
  assistantId: string;
  ruleId: string;
}

export const requestDeleteRule = async ({
  assistantId,
  ruleId
}: DeleteRuleBody): Promise<{ success: boolean }> =>
  await instance.delete(buildUrl(rulesBase(assistantId), ruleId));

export interface ReorderRulesBody {
  assistantId: string;
  items: { id: string; sortOrder: number }[];
}

export const requestReorderRules = async ({
  assistantId,
  items
}: ReorderRulesBody): Promise<ListResponse> =>
  await instance.patch(
    buildUrl(ApiRoutesAiAssistants.Assistants, assistantId, AiAssistantSubRoute.ReorderRules),
    { items }
  );
